import { useRequest } from '../hooks/UseRequest';
import { useDispatch } from 'react-redux';
import { setNotification } from '../redux/notificationSlice';

export const NotificationService = () => {
  const requests = useRequest();
  const dispatch = useDispatch();

  const markNotificationAsViewed = async (notification_id) => {
    try {
      requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/notification/viewed/${notification_id}`);
      await requests.edit();
    } catch (err) {
      dispatch(setNotification({ type: 'error', body: err.response?.data?.message }));
    }
  };

  return { markNotificationAsViewed };
};
